import CampaignPreviewCard from './CampaignPreviewCard';

export default CampaignPreviewCard;
